export const GRID_TREE_DATA_GROUPING_FIELD = '__tree_data_group__';
export const GRID_ROW_GROUPING_SINGLE_GROUPING_FIELD = '__row_group_by_columns_group__';
export const GRID_DETAIL_PANEL_TOGGLE_FIELD = '__detail_panel_toggle__';
export enum PinnedColumnPosition {
  NONE,
  LEFT,
  RIGHT,
  VIRTUAL,
}
